import { render, staticRenderFns } from "./ConfirmProjectState.vue?vue&type=template&id=bc2b1b46&scoped=true"
import script from "./ConfirmProjectState.vue?vue&type=script&lang=js"
export * from "./ConfirmProjectState.vue?vue&type=script&lang=js"
import style0 from "./ConfirmProjectState.vue?vue&type=style&index=0&id=bc2b1b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2b1b46",
  null
  
)

export default component.exports